{
  "cms.benefit.field.title": "Otsikko",
  "cms.benefit.field.logo": "Logo / kuva",
  "cms.benefit.field.body": "Lisätietoja (näkyy haitarissa)",
  "cms.benefit.field.category": "Kategoria",
  "cms.benefit.field.categoryPlaceholder": "Valitse kategoria",
  "cms.benefit.field.categoryAddNew": "+ Lisää uusi kategoria",
  "cms.benefit.field.cities": "Kaupungit",
  "cms.benefit.field.link": "Linkki (URL)",
  "cms.benefit.error.titleRequired": "Otsikko on pakollinen (enintään 200 merkkiä).",
  "cms.benefit.error.titleNotDerivable": "Otsikossa on oltava vähintään yksi latinalainen kirjain tai numero.",
  "cms.benefit.error.logoUrl": "Logo-URL:n on alettava https:// tai oltava sama-alkuperäinen polku (/media/...).",
  "cms.benefit.error.linkHttps": "Linkin on oltava https://-osoite."
}
